import React from 'react'
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    Cell
} from "recharts";

// const data = [
//     { "month": "Jan", "users": 123, "queries": 345 },
//     { "month": "Feb", "users": 123, "queries": 123 },
//     { "month": "Mar", "users": 123, "queries": 12 }
// ]

const BarCharts = ({ data, nameKey, title, colors, xAxisName, horizontal = false }) => {
    const enableScroll = data.length > 8;
    return (
        <div className="w-full h-full flex flex-col">
            <h1 className='font-semibold mb-8 ml-2'>{title}</h1>
            <div className={`flex-1 min-h-0 ${enableScroll && !horizontal ? "overflow-x-auto" : "overflow-x-hidden"}
                                    ${enableScroll && horizontal ? "overflow-y-auto" : "overflow-y-hidden"} sm:overflow-hidden`}>
                <div className={`h-full ${enableScroll && !horizontal ? "min-w-[500px]" : "min-w-0"} 
                ${enableScroll && horizontal ? "min-h-[500px]" : "min-h-0"} sm:min-w-0`}>
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={data} layout={horizontal ? "vertical" : "horizontal"} margin={{ top: 20, right: 20 }}>
                            <CartesianGrid strokeDasharray="3 3" />
                            {horizontal ? (
                                <div>
                                    <XAxis type="number" />
                                    <YAxis type="category" dataKey={nameKey}
                                        tick={{ fontSize: 12 }}
                                        textAnchor="end"
                                        interval={0}
                                        width={90} />
                                </div>
                            ) : (
                                <div>
                                    <XAxis dataKey={nameKey}
                                        angle={-30}
                                        textAnchor="end"
                                        interval={0}
                                        height={60}
                                        tick={{ fontSize: 10 }} />
                                    <YAxis />
                                </div>
                            )}
                            {/* <XAxis dataKey={nameKey}
                            angle={-30}
                            textAnchor="end"
                            interval={0}
                            height={60} />
                        <YAxis /> */}
                            <Tooltip />
                            <Legend />
                            <Bar
                                dataKey="count"
                                name={xAxisName}
                                label={{
                                    position: horizontal ? "right" : "top",
                                    fontSize: 12
                                }}
                            >
                                {data.map((entry, index) => (
                                    <Cell
                                        key={`cell-${index}`}
                                        fill={colors[index % colors.length]}
                                    />
                                ))}
                            </Bar>

                        </BarChart>
                    </ResponsiveContainer>
                </div>

            </div>


        </div>
    )
}

export default BarCharts
